import {
  SessionStorage,
  LocalStorage
} from '../burger-king-lib/utils/storage.web';
import { LocalSessionKey } from '../burger-king-lib/constants/app-constants';
import { PRE_BOOK_STATUS } from '../constants/app-constants';
// import { THEME } from '../constants/app-constants';

// const { RESTAURANT, DELIVERY } = THEME;

export const deliveryAddressStorage = {
  get() {
    return SessionStorage.get('DELIVERY_ADDRESS');
  },
  set(value) {
    SessionStorage.set('DELIVERY_ADDRESS', value);
  }
};

export const restaurantAddressStorage = {
  get() {
    // return this.address;
    return SessionStorage.get(LocalSessionKey.RESTAURANT_DETAIL);
  },
  set(value) {
    SessionStorage.set(LocalSessionKey.RESTAURANT_DETAIL, value);
    // this.address = value;
  }
};

export function getCartItemCountAndPrice(data) {
  if (data && data.items_count) {
    return {
      price: data.total_price || 0,
      quantity: data.items_count,
      offer: data.offer_detail
    };
  }
  if (data && data.length) {
    const [firEl] = data;
    let quantityValue = 0;
    const { delivery_charges, packing_charges, total_payable_amount } = firEl;
    if (firEl && firEl.products) {
      firEl.products.map(item => {
        const { quantity } = item;
        if (quantity) quantityValue += quantity;
        return item;
      });
    }
    return {
      price: (firEl && firEl.total_price) || 0,
      quantity: quantityValue,
      delivery_charges,
      packing_charges,
      total_payable_amount
    };
  }
  return {
    price: 0,
    quantity: 0,
    delivery_charges: 0,
    packing_charges: 0,
    total_payable_amount: 0
  };
}
export function getCartItemCountAndPrice1(data) {
  if (data && data.items_count) {
    return {
      price: data.total_price || 0,
      quantity: data.items_count,
      offer: data.offer_detail
    };
  }
  if (data && data.cart_items) {
    let quantityValue = 0;
    const {
      delivery_charges,
      packaging_charges: packing_charges,
      total_payable_amount,
      total_taxable_amount
    } = data;
    Object.values(data.cart_items).map(item => {
      const { quantity } = item;
      if (quantity) quantityValue += quantity;
      return item;
    });
    return {
      price: total_taxable_amount,
      quantity: quantityValue,
      delivery_charges,
      packing_charges,
      mprice: total_taxable_amount - packing_charges - delivery_charges,
      total_payable_amount
    };
  }
  return {
    price: 0,
    quantity: 0,
    delivery_charges: 0,
    packing_charges: 0,
    total_payable_amount: 0
  };
}

export function generateSelectedAddonsName(data) {
  const { addons } = data;
  let addonConcat = '';
  if (addons && Object.values(addons).length)
    Object.values(addons).forEach(addonData => {
      if (addonConcat) addonConcat += ' + ';
      addonConcat +=
        addonData.quantity > 1
          ? `${addonData.product_name} * ${addonData.quantity}`
          : addonData.product_name;
      return addonData;
    });
  return addonConcat;
}
// eslint-disable-next-line
export function getCartTotalPayableAmount(cartData, theme, orderType) {
  // eslint-disable-next-line
  const { delivery_charges, packing_charges, total_payable_amount } = cartData;
  const tempPrice = total_payable_amount;
  return tempPrice;
}

export function getPriceDelimitedString(value) {
  if (value) {
    return Number(value)
      .toFixed(2)
      .toLocaleString();
  }
  return value;
}

export function getCategoryImage(imageUrls, categoryName) {
  if (imageUrls) {
    const filterCategory = imageUrls?.filter(
      data => data?.category === categoryName
    );
    const imageArr =
      filterCategory && filterCategory[0] && filterCategory[0]?.images;

    const { innerWidth } = window;
    let name = 'desktop';

    if (innerWidth <= 400) name = 'mobile_sm';
    else if (innerWidth <= 996) name = 'mobile_lg';

    if (imageArr && imageArr?.length) {
      const imageFilter = imageArr?.filter(data => data?.name === name);
      return imageFilter && imageFilter[0] && imageFilter[0]?.image;
    }
    return {};
  }

  return {};
}

export function setInitialPayment() {
  const restaurantDetail = JSON.parse(
    window?.sessionStorage?.getItem('RESTAURANT_DETAIL')
  );
  return restaurantDetail?.is_razorpay_enabled ? 'RAZORPAY' : 'JUSPAY';
}

export function getImageUrls(imageArr) {
  const { innerWidth } = window;
  let name = 'desktop';

  if (innerWidth <= 576) name = 'mobile_sm';
  if (innerWidth <= 996) name = 'mobile_lg';

  const imageFilter = imageArr.filter(data => data.name === name);
  return imageFilter && imageFilter[0];
}

export function getMobileHeight(size) {
  const { innerWidth } = window;
  const newSize = size * (innerWidth / 375);
  return Math.round(newSize);
}

export function getDesktopHeight(size) {
  let { innerWidth } = window;
  if (innerWidth > 1920) innerWidth = 1920;
  const newSize = size * (innerWidth / 1440);
  return Math.round(newSize);
}

export function splitAddress(address) {
  let newAddress;
  if (!address) {
    newAddress = '';
  } else {
    newAddress = address
      .replace(/[' ']/g, '+')
      .replace(/[',']/g, '%2C')
      .replace(/['#']/g, '%23')
      .replace(/[' & ']/g, '%26')
      .replace(/[' ( ']/g, '%28')
      .replace(/[' ) ']/g, '%29');
  }
  return newAddress;
}

export const cartValueStorage = {
  get() {
    return LocalStorage.get('CART DETAILS');
  },
  set(value) {
    LocalStorage.set('CART DETAILS', value);
  },
  clearAll() {
    LocalStorage.clearAll();
  }
};

export const cartDetails = {
  get() {
    return LocalStorage.get('CART VALUES');
  },
  set(value) {
    LocalStorage.set('CART VALUES', value);
  },
  clearAll() {
    LocalStorage.clearAll();
  }
};

export const getUserID = () => {
  return LocalStorage.get(LocalSessionKey.USER_ID);
};

export const getUserData = () => {
  return LocalStorage.get(LocalSessionKey.USER_DATA);
};

export const setOutletIdComesFromDeeplink = () => {
  const deepLinkOutletId = sessionStorage.getItem(
    LocalSessionKey.DEEP_LINK_OUTLET_ID
  );

  if (deepLinkOutletId) {
    sessionStorage.setItem(LocalSessionKey.OUTLET_ID, deepLinkOutletId);
  }
};

export const checkServiceTypeSelectedOrNot = () =>
  sessionStorage.getItem(LocalSessionKey.IS_SERVICE_TYPE_SELECTED_ONECE);

export const updateServiceTypeSelectedToSessionStorage = () =>
  sessionStorage.setItem(LocalSessionKey.IS_SERVICE_TYPE_SELECTED_ONECE, true);

export const createSlug = text =>
  text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/--+/g, '-');

export const getMoengageAddonsPayload = (addons = []) => {
  const result = {};

  if (!Array.isArray(addons || addons.length === 0)) return result;

  addons.forEach(addon => {
    result.addon_name = [
      ...(Array.isArray(result?.addon_name) ? result.addon_name : []),
      addon?.name || addon?.product_name || ''
    ];
    result.addon_price = [
      ...(Array.isArray(result?.addon_price) ? result.addon_price : []),
      addon?.price || addon?.item_price || 0
    ];
    result.addon_quantity = [
      ...(Array.isArray(result?.addon_quantity) ? result.addon_quantity : []),
      addon.quantity || 0
    ];

    result.addon_id = [
      ...(Array.isArray(result?.addon_id) ? result.addon_id : []),
      (addon?.entity_id || '')
        .toString()
        .toLowerCase()
        .replace(/^p::/gi, '')
    ];
  });

  if (addons.length > 0) {
    result.total_addon_price =
      result?.addon_price?.reduce((acc, price) => acc + Number(price), 0) || 0;
  }

  return { ...result };
};

export const getCategoryIdFromString = (categoryId = '') =>
  typeof categoryId !== 'string'
    ? ''
    : categoryId.toLowerCase().replace(/pv::/, '');

export const getCategoryIdFromArray = (categories = []) =>
  Array.isArray(categories) ? [...categories.map(getCategoryIdFromString)] : [];

export const extractCartData = cartData => {
  const moengagePayload = {
    addon_id: [],
    addon_name: [],
    addon_price: [],
    addon_quantity: [],
    product_name: [],
    product_price: [],
    product_actual_price: [],
    product_quantity: [],
    category_id: [],
    category_name: [],
    total_quantity: 0,
    total_addon_price: 0
  };

  if (cartData?.cart_items) {
    const cartList = Object.values(cartData?.cart_items);
    if (cartList.length > 0) {
      moengagePayload.total_quantity = cartList.length;
      cartList.forEach(item => {
        moengagePayload.product_name = [
          ...(Array.isArray(moengagePayload.product_name)
            ? moengagePayload.product_name
            : []),
          item.product_name || ''
        ];

        moengagePayload.product_actual_price = [
          ...(Array.isArray(moengagePayload.product_actual_price)
            ? moengagePayload.product_actual_price
            : []),
          `${item?.unit_price || ''}`
        ];

        moengagePayload.product_price = [
          ...(Array.isArray(moengagePayload.product_price)
            ? moengagePayload.product_price
            : []),
          `${item?.unit_price - item?.savings || ''}`
        ];

        moengagePayload.category_id = [
          ...(Array.isArray(moengagePayload.category_id)
            ? getCategoryIdFromArray(moengagePayload.category_id)
            : []),
          getCategoryIdFromString(item.category_id) || ''
        ];

        moengagePayload.category_name = [
          ...(Array.isArray(moengagePayload.category_name)
            ? moengagePayload.category_name
            : []),
          item.category_name || ''
        ];
        moengagePayload.product_quantity = [
          ...(Array.isArray(moengagePayload.product_quantity)
            ? moengagePayload.product_quantity
            : []),
          item.quantity || 0
        ];

        // If addons are there then addons data
        if (Object.values(item?.addons || {}).length > 0) {
          moengagePayload.addon_name = [
            ...(Array.isArray(moengagePayload.addon_name)
              ? moengagePayload.addon_name
              : []),
            ...getMoengageAddonsPayload(Object.values(item?.addons || {}))
              .addon_name
          ];

          moengagePayload.addon_price = [
            ...(Array.isArray(moengagePayload.addon_price)
              ? moengagePayload.addon_price
              : []),
            ...getMoengageAddonsPayload(Object.values(item?.addons || {}))
              .addon_price
          ];

          moengagePayload.addon_quantity = [
            ...(Array.isArray(moengagePayload.addon_quantity)
              ? moengagePayload.addon_quantity
              : []),
            ...getMoengageAddonsPayload(Object.values(item?.addons || {}))
              .addon_quantity
          ];

          moengagePayload.addon_id = [
            ...(Array.isArray(moengagePayload.addon_id)
              ? moengagePayload.addon_id
              : []),
            ...getMoengageAddonsPayload(Object.values(item?.addons || {}))
              .addon_id
          ];
        }
      });

      moengagePayload.total_addon_price = moengagePayload.addon_price.reduce(
        (acc, price) => acc + Number(price),
        0
      );
    }
  }

  if (moengagePayload.addon_name.length === 0) {
    delete moengagePayload.addon_name;
  }

  if (moengagePayload.addon_price.length === 0) {
    delete moengagePayload.addon_price;
    delete moengagePayload.total_addon_price;
  }

  if (moengagePayload.addon_quantity.length === 0) {
    delete moengagePayload.addon_quantity;
  }

  if (moengagePayload.addon_id.length === 0) {
    delete moengagePayload.addon_id;
  }

  return moengagePayload;
};

export const formatCurrency = (amount = 0, currency = 'INR') => {
  return new Intl.NumberFormat('en-IN', {
    currency: currency || 'INR',
    style: 'currency'
  }).format(amount || 0);
};

export const formatDateTime = (date = new Date()) => {
  if (!date) return '';

  const d = new Date(date);
  if (Number.isNaN(d.getTime())) {
    return '';
  }

  return d
    .toLocaleString('en-GB', {
      timeZone: 'Asia/Kolkata',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    })
    .replace(' pm', ' PM')
    .replace(' am', ' AM');
};

export const formatMonthDate = (date = new Date()) => {
  if (!date) return '';

  const d = new Date(date);

  if (Number.isNaN(d.getTime())) {
    return '';
  }

  return d.toLocaleDateString('en-GB', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: 'long'
  });
};

export const formatDate = (date = new Date()) => {
  if (!date) return '';

  const d = new Date(date);

  if (Number.isNaN(d.getTime())) {
    return '';
  }

  return d.toLocaleDateString('en-GB', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};
export const checkIsPreMealItem = item => {
  if (!item) return false;

  if (!Array.isArray(item?.tags)) return false;

  return item?.tags.some(tag => tag.toLowerCase() === 'doomsday');
};

export const maskMobileNumber = mobileNumber => {
  if (!mobileNumber) return '';

  const digits = String(mobileNumber).replace(/\D/g, '');
  const number = digits.length > 10 ? digits.slice(-10) : digits;

  if (number.length !== 10) return mobileNumber;

  return `+91 •••••• ${number.slice(-4)}`;
};

export const extraPreBookMealInfo = (preBook = null) => {
  if (!preBook) return null;

  const unLocksAt = formatDateTime(preBook?.unlock_at);
  const redeemUntil = formatDate(preBook?.redeem_until);

  const redeemMonthDay = formatMonthDate(preBook?.redeem_until);
  const unlockMonthDay = formatMonthDate(preBook?.unlock_at);
  const isPrebookingOpened = preBook?.is_launch;
  // Initially in the
  let status = PRE_BOOK_STATUS.RESERVED;
  let products = [];

  const prebookings = preBook?.prebookings;
  const isPrebookingRedeemExpired =
    Date.now() >= new Date(preBook?.redeem_until).getTime();

  if (Array.isArray(prebookings) && prebookings.length > 0) {
    products = prebookings.flatMap(prebooking => {
      if (Array.isArray(prebooking?.products)) {
        return prebooking?.products.map(each => ({
          ...each,
          amount: prebooking?.amount
        }));
      }
      return [];
    });
    if (isPrebookingRedeemExpired) {
      status = PRE_BOOK_STATUS.EXPIRED;
    }

    if (isPrebookingOpened && !isPrebookingRedeemExpired) {
      status = PRE_BOOK_STATUS.RESERVED;
    } else {
      const isAllAreExpired = products.every(
        product => product?.prebook_status === PRE_BOOK_STATUS.EXPIRED
      );

      if (isAllAreExpired) {
        status = PRE_BOOK_STATUS.EXPIRED;
      }

      const isAllProductsAreRedeemed = products.every(
        product => product?.prebook_status === PRE_BOOK_STATUS.REDEEMED
      );

      if (isAllProductsAreRedeemed) {
        status = PRE_BOOK_STATUS.REDEEMED;
      }
    }
  }
  const mobileNumber = maskMobileNumber(
    localStorage.getItem(LocalSessionKey.USER_DATA)
  );

  const getButtonName = () => {
    const data = {
      eyeBrowName: 'DOOMSDAY RESERVED',
      homeButtonName: 'VIEW PRE-BOOKING',
      homeHeading: 'Your meal is reserved.',
      homeDescription: `Unlocks ${unLocksAt} for dine-in redemption.`
    };

    switch (status) {
      case 'RESERVED': {
        if (!isPrebookingOpened) {
          data.eyeBrowName = 'THE D-DAY IS HERE!';
          data.homeButtonName = 'REDEEM NOW';
          data.homeHeading = 'Your meal awaits you!';
          data.homeDescription =
            'Choose a restaurant and redeem your guaranteed dine-in meal.';
        }
        return {
          ...data
        };
      }

      case 'REDEEMED': {
        return {
          ...data,
          homeButtonName: 'VIEW ORDER',
          eyeBrowName: 'DOOMSDAY . REDEEMED',
          homeHeading: 'Your meal was redeemed.',
          homeDescription: 'Your dine-in order has been placed successfully.'
        };
      }

      case 'EXPIRED': {
        return {
          ...data,
          homeButtonName: 'VIEW DETAILS',
          eyeBrowName: 'DOOMSDAY . EXPIRED',
          homeHeading: 'Oops! Your Pre-Booking Has Expired',
          homeDescription: `The redemption window for your Doomsday Meal has ended. 
            Don't worry! 
            Your pre-booking amount has been
            credited to your BK Wallet.`
        };
      }

      case 'REFUNDED': {
        return {
          ...data,
          eyeBrowName: 'DOOMSDAY . REFUNDED'
        };
      }
      default:
        return data;
    }
  };

  return {
    unLocksAt,
    redeemUntil,
    mobileNumber,
    products,
    status,
    isPrebookingOpened,
    isPrebookingRedeemExpired,
    redeemMonthDay,
    unlockMonthDay,
    ...getButtonName()
  };
};

export const extractRedeemInfo = redeemedPrebookInfo => {
  const orderId = redeemedPrebookInfo?.bk_order_id;
  const productName = redeemedPrebookInfo?.prebooking?.product_name;
  const preBookId = redeemedPrebookInfo?.prebooking?.prebook_code;
  return {
    orderId,
    preBookId,
    productName
  };
};
